const useKeyPress = (keyPressCond, handlerInput) => {
    return (event) => {
        if (keyPressCond(event)) handlerInput(event)
    }
}

export default useKeyPress;